/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthSubscribeRouteImport } from './routes/_auth/subscribe'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthSelectUserRouteImport } from './routes/_auth/select-user'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotStaffPasswordRouteImport } from './routes/_auth/forgot-staff-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AuthAcceptTermsRouteImport } from './routes/_auth/accept-terms'
import { Route as Auth2faVerifyRouteImport } from './routes/_auth/2fa-verify'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppRemindersRouteImport } from './routes/_app/reminders'
import { Route as AppReceiptsRouteImport } from './routes/_app/receipts'
import { Route as AppPatientsRouteImport } from './routes/_app/patients'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppDispensesRouteImport } from './routes/_app/dispenses'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppActivityRouteImport } from './routes/_app/activity'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubscribeRoute = AuthSubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelectUserRoute = AuthSelectUserRouteImport.update({
  id: '/select-user',
  path: '/select-user',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotStaffPasswordRoute = AuthForgotStaffPasswordRouteImport.update({
  id: '/forgot-staff-password',
  path: '/forgot-staff-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptTermsRoute = AuthAcceptTermsRouteImport.update({
  id: '/accept-terms',
  path: '/accept-terms',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faVerifyRoute = Auth2faVerifyRouteImport.update({
  id: '/2fa-verify',
  path: '/2fa-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppRemindersRoute = AppRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AppRoute,
} as any)
const AppReceiptsRoute = AppReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => AppRoute,
} as any)
const AppPatientsRoute = AppPatientsRouteImport.update({
  id: '/patients',
  path: '/patients',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppDispensesRoute = AppDispensesRouteImport.update({
  id: '/dispenses',
  path: '/dispenses',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof AppActivityRoute
  '/alerts': typeof AppAlertsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/audit': typeof AppAuditRoute
  '/dashboard': typeof AppDashboardRoute
  '/dispenses': typeof AppDispensesRoute
  '/inventory': typeof AppInventoryRoute
  '/patients': typeof AppPatientsRoute
  '/receipts': typeof AppReceiptsRoute
  '/reminders': typeof AppRemindersRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/2fa-verify': typeof Auth2faVerifyRoute
  '/accept-terms': typeof AuthAcceptTermsRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/forgot-staff-password': typeof AuthForgotStaffPasswordRoute
  '/login': typeof AuthLoginRoute
  '/select-user': typeof AuthSelectUserRoute
  '/signup': typeof AuthSignupRoute
  '/subscribe': typeof AuthSubscribeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof AppActivityRoute
  '/alerts': typeof AppAlertsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/audit': typeof AppAuditRoute
  '/dashboard': typeof AppDashboardRoute
  '/dispenses': typeof AppDispensesRoute
  '/inventory': typeof AppInventoryRoute
  '/patients': typeof AppPatientsRoute
  '/receipts': typeof AppReceiptsRoute
  '/reminders': typeof AppRemindersRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/2fa-verify': typeof Auth2faVerifyRoute
  '/accept-terms': typeof AuthAcceptTermsRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/forgot-staff-password': typeof AuthForgotStaffPasswordRoute
  '/login': typeof AuthLoginRoute
  '/select-user': typeof AuthSelectUserRoute
  '/signup': typeof AuthSignupRoute
  '/subscribe': typeof AuthSubscribeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/activity': typeof AppActivityRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/dispenses': typeof AppDispensesRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/patients': typeof AppPatientsRoute
  '/_app/receipts': typeof AppReceiptsRoute
  '/_app/reminders': typeof AppRemindersRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/users': typeof AppUsersRoute
  '/_auth/2fa-verify': typeof Auth2faVerifyRoute
  '/_auth/accept-terms': typeof AuthAcceptTermsRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/forgot-staff-password': typeof AuthForgotStaffPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/select-user': typeof AuthSelectUserRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/subscribe': typeof AuthSubscribeRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/alerts'
    | '/analytics'
    | '/audit'
    | '/dashboard'
    | '/dispenses'
    | '/inventory'
    | '/patients'
    | '/receipts'
    | '/reminders'
    | '/reports'
    | '/settings'
    | '/users'
    | '/2fa-verify'
    | '/accept-terms'
    | '/change-password'
    | '/forgot-password'
    | '/forgot-staff-password'
    | '/login'
    | '/select-user'
    | '/signup'
    | '/subscribe'
    | '/verify-email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/alerts'
    | '/analytics'
    | '/audit'
    | '/dashboard'
    | '/dispenses'
    | '/inventory'
    | '/patients'
    | '/receipts'
    | '/reminders'
    | '/reports'
    | '/settings'
    | '/users'
    | '/2fa-verify'
    | '/accept-terms'
    | '/change-password'
    | '/forgot-password'
    | '/forgot-staff-password'
    | '/login'
    | '/select-user'
    | '/signup'
    | '/subscribe'
    | '/verify-email'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/activity'
    | '/_app/alerts'
    | '/_app/analytics'
    | '/_app/audit'
    | '/_app/dashboard'
    | '/_app/dispenses'
    | '/_app/inventory'
    | '/_app/patients'
    | '/_app/receipts'
    | '/_app/reminders'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/users'
    | '/_auth/2fa-verify'
    | '/_auth/accept-terms'
    | '/_auth/change-password'
    | '/_auth/forgot-password'
    | '/_auth/forgot-staff-password'
    | '/_auth/login'
    | '/_auth/select-user'
    | '/_auth/signup'
    | '/_auth/subscribe'
    | '/_auth/verify-email'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/subscribe': {
      id: '/_auth/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof AuthSubscribeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/select-user': {
      id: '/_auth/select-user'
      path: '/select-user'
      fullPath: '/select-user'
      preLoaderRoute: typeof AuthSelectUserRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-staff-password': {
      id: '/_auth/forgot-staff-password'
      path: '/forgot-staff-password'
      fullPath: '/forgot-staff-password'
      preLoaderRoute: typeof AuthForgotStaffPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-terms': {
      id: '/_auth/accept-terms'
      path: '/accept-terms'
      fullPath: '/accept-terms'
      preLoaderRoute: typeof AuthAcceptTermsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/2fa-verify': {
      id: '/_auth/2fa-verify'
      path: '/2fa-verify'
      fullPath: '/2fa-verify'
      preLoaderRoute: typeof Auth2faVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reminders': {
      id: '/_app/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof AppRemindersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receipts': {
      id: '/_app/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof AppReceiptsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/patients': {
      id: '/_app/patients'
      path: '/patients'
      fullPath: '/patients'
      preLoaderRoute: typeof AppPatientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispenses': {
      id: '/_app/dispenses'
      path: '/dispenses'
      fullPath: '/dispenses'
      preLoaderRoute: typeof AppDispensesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDispensesRoute: typeof AppDispensesRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppPatientsRoute: typeof AppPatientsRoute
  AppReceiptsRoute: typeof AppReceiptsRoute
  AppRemindersRoute: typeof AppRemindersRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppUsersRoute: typeof AppUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppAuditRoute: AppAuditRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDispensesRoute: AppDispensesRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppPatientsRoute: AppPatientsRoute,
  AppReceiptsRoute: AppReceiptsRoute,
  AppRemindersRoute: AppRemindersRoute,
  AppReportsRoute: AppReportsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppUsersRoute: AppUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  Auth2faVerifyRoute: typeof Auth2faVerifyRoute
  AuthAcceptTermsRoute: typeof AuthAcceptTermsRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthForgotStaffPasswordRoute: typeof AuthForgotStaffPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSelectUserRoute: typeof AuthSelectUserRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthSubscribeRoute: typeof AuthSubscribeRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faVerifyRoute: Auth2faVerifyRoute,
  AuthAcceptTermsRoute: AuthAcceptTermsRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthForgotStaffPasswordRoute: AuthForgotStaffPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSelectUserRoute: AuthSelectUserRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthSubscribeRoute: AuthSubscribeRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
